import styled from 'styled-components'
import { color } from 'utils'

type StyledSelectProps = { hasError?: boolean }
const Select = styled.select<StyledSelectProps>`
  padding: 0.75rem 1rem;
  color: ${color('white')};
  background: ${color('dark900')};
  border: 1px solid ${(p) => (p.hasError ? color('errorMuted') : color('dark500'))};
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  outline: none;

  :focus {
    border-color: ${color('primaryMuted')};
  }
`

export default Select
